import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityDocuments } from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  items: "InboxItem.Items",
  list: "InboxItem.ItemList",
  new: "InboxItem.ItemNew",
  base: "InboxItem.ItemBase",
  view: "InboxItem.ItemView",
  edit: "InboxItem.ItemEdit",
  notes: "InboxItem.ItemNotes",
  noteEdit: "InboxItem.ItemNoteEdit",
  noteNew: "InboxItem.ItemNoteNew",
  // documents: "InboxItem.ItemDocuments",
  // documentsEdit: "InboxItem.ItemDocumentsEdit",
  // documentsNew: "InboxItem.ItemDocumentsNew",
  workFlowTasks: "InboxItem.ItemWorkFlowTasks",
  workFlowTaskEdit: "InboxItem.ItemWorkFlowTaskEdit",
  workFlowTaskNew: "InboxItem.ItemWorkFlowTaskNew",
  audit: "InboxItem.ItemAudit",
};

export { names as inboxItemRouteNames };

const inboxItemRoutes: RouterOptions["routes"] = [
  {
    path: "/inboxItem",
    name: names.items,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Inbox Items" },
        component: () => import("@/views/inboxItem/InboxItemList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/inboxItem/InboxItemBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Inbox Item", isNew: true },
            component: () => import("@/views/inboxItem/InboxItemEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/inboxItem/InboxItemBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Inbox Item View" },
            component: () => import("@/views/inboxItem/InboxItemView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Inbox Item Edit", isForm: true },
            component: () => import("@/views/inboxItem/InboxItemEdit.vue"),
          },
          {
            path: "workFlowTasks",
            name: names.workFlowTasks,
            meta: { title: "Inbox Item Workflow Task", lookupGroups: ["TaskStatus", "TaskPriority", "Employee"] },
            component: () => import("@/views/inboxItem/WorkFlowTasksChildList.vue"),
          },
          {
            path: "workFlowTasks/:workFlowTaskId(\\d+)",
            name: names.workFlowTaskEdit,
            meta: { title: "Edit Inbox Item Workflow Task", isForm: true },
            component: () => import("@/views/inboxItem/InboxItemWorkFlowTask.vue"),
          },
          {
            path: "workFlowTasks/new",
            name: names.workFlowTaskNew,
            meta: { title: "Create Inbox Item Workflow Task", isForm: true },
            component: () => import("@/views/inboxItem/InboxItemWorkFlowTask.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Inbox Item Notes" },
            component: {
              render: () => <EntityNotes idField="mailItemId" routeNamePrefix="InboxItem.ItemNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Inbox Item Note", isForm: true },
            component: () => import("@/views/inboxItem/InboxItemNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Inbox Item Note", isForm: true },
            component: () => import("@/views/inboxItem/InboxItemNote.vue"),
          },
          // {
          //   path: "documents",
          //   name: names.documents,
          //   meta: { title: "Inbox Item Documents" },
          //   component: {
          //     render: () => <EntityDocuments idField="mailItemId" routeNamePrefix="InboxItem.ItemDocuments" />,
          //   },
          // },
          // {
          //   path: "documents/:documentId(\\d+)",
          //   name: names.documentsEdit,
          //   meta: { title: "Edit Inbox Item Document", isForm: true },
          //   component: () => import("@/views/inboxItem/InboxDocument.vue"),
          // },
          // {
          //   path: "documents/new",
          //   name: names.documentsNew,
          //   meta: { title: "Create Inbox Item Documents", isForm: true },
          //   component: () => import("@/views/inboxItem/InboxDocuments.vue"),
          // },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Inbox Item Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Item" />,
            },
          },
        ],
      },
    ],
  },
];
export default inboxItemRoutes;
